import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  BatchesClient,
  FillSitesClient,
  IBatchAttachmentViewModel,
  ISourceSiteAttachmentViewModel,
  SourceSitesClient
} from '@services/cleanfill-api/cleanfill-api.generated';
import { AttachmentFileType } from '@view-models/enums/attachment-file-type.enum';
import { SiteType } from '@view-models/enums/site-type.enum';
import * as fileSaver from 'file-saver';
@Component({
  selector: 'file-preview',
  templateUrl: './file-preview.component.html',
  styleUrls: ['./file-preview.component.scss']
})
export class FilePreviewComponent implements OnInit {
  @Input() edit: boolean;
  @Input() download: boolean;
  @Input() type: SiteType;
  @Input() file: IBatchAttachmentViewModel | ISourceSiteAttachmentViewModel;
  @Output() delete = new EventEmitter<IBatchAttachmentViewModel | ISourceSiteAttachmentViewModel>();

  constructor(
    private batchesClient: BatchesClient,
    private fillSitesClient: FillSitesClient,
    private sourceSitesClient: SourceSitesClient
  ) {
    this.edit = true;
    this.download = true;
  }

  ngOnInit(): void {}

  formatExt(ext: string) {
    const label = AttachmentFileType[ext];
    return label ?? 'NOT SUPPORTED';
  }
  onDownloadFile() {
    switch (this.type) {
      case SiteType.SOURCE_SITE:
        this.sourceSoteDownloadFile();
        break;
      case SiteType.FILL_SITE:
        this.fillSiteDownloadFile();
        break;
      default:
        this.batchDownloadFile();
        return;
    }
  }
  batchDownloadFile() {
    this.batchesClient
      .downloadBatchAttachment(this.file.uniqueId, undefined)
      .toPromise()
      .then(t => {
        fileSaver.saveAs(t.data, t.fileName);
      });
  }
  sourceSoteDownloadFile() {
    this.sourceSitesClient
      .downloadSourceSiteAttachment(this.file.uniqueId, undefined)
      .toPromise()
      .then(t => {
        fileSaver.saveAs(t.data, t.fileName);
      });
  }
  fillSiteDownloadFile() {
    this.fillSitesClient
      .downloadFillSiteAttachment(this.file.uniqueId, undefined)
      .toPromise()
      .then(t => {
        fileSaver.saveAs(t.data, t.fileName);
      });
  }
}
